export const isOldPHPView = () => {
	return typeof $().foundation === 'function';
};
